import { Autocomplete, Chip, TextField } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { TagDto } from '../../common/PricePrgClient';
import { RootState } from '../../store';
import { getAllTags } from '../tags/redux/tagSlices';
import { getAgreementTags, updateAgreementTags } from './redux/agreementSlices';

const mapStateToProps = (state: RootState) => ({
    selectedAgreement: state.agreement.ui.agreementId,
    tags: state.tags.tags
});

type OwnProps = {
    agreementTags: TagDto[];
};
type Props = ReturnType<typeof mapStateToProps> & OwnProps;
const AgreementTags = ({ selectedAgreement, tags, agreementTags }: Props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllTags.request());
        if (selectedAgreement != null) {
            dispatch(getAgreementTags.request(selectedAgreement));
        }
    }, [selectedAgreement, dispatch]);

    const aTags = useMemo(() => {
        return agreementTags;
    }, [agreementTags]);

    const handleChange = (event, values: TagDto[]) => {
        if (selectedAgreement != null) {
            dispatch(
                updateAgreementTags.request({
                    agreementId: selectedAgreement,
                    tags: values.map(c => c.tagId)
                })
            );
        }
    };
    return (
        <Autocomplete
            multiple
            id="tags-outlined"
            options={Object.values(tags)}
            getOptionLabel={option => option.shortName}
            value={agreementTags}
            defaultValue={aTags}
            filterSelectedOptions
            isOptionEqualToValue={(option, value) => option.tagId === value.tagId}
            onChange={handleChange}
            renderInput={params => <TextField {...params} label="Tags" placeholder="Tag" />}
            renderTags={(value: readonly TagDto[], getTagProps) =>
                value.map((option: TagDto, index: number) => (
                    <Chip
                        variant="outlined"
                        sx={{ backgroundColor: option.color }}
                        label={option.shortName}
                        {...getTagProps({ index })}
                        key={option.tagId}
                    />
                ))
            }
        />
    );
};

export default connect(mapStateToProps)(AgreementTags);
